import { noteForIndex, triggerMomentary, type InstrumentPlayerProps } from "../playerTypes";

export function SitarPlayer(props: InstrumentPlayerProps) {
  return (
    <div className="instrument-ui sitar-ui" data-testid="instrument-player-sitar">
      <div className="sitar-neck" aria-label="Sitar long neck with curved frets">
        {Array.from({ length: 9 }, (_, index) => (
          <button key={index} type="button" className="sitar-fret" aria-label={`Play sitar main string fret ${index + 1}`} onClick={() => triggerMomentary(props, noteForIndex(props.instrument.playableNotes, index), "mizraab", 0.7, 520)}>
            <span />
          </button>
        ))}
      </div>
      <div className="sympathetic-strings" aria-label="Sympathetic strings visualization">
        {Array.from({ length: 12 }, (_, index) => (
          <span key={index} />
        ))}
      </div>
      <div className="instrument-control-strip">
        {props.variant.chikari?.strings.map((stringId, index) => (
          <button key={stringId} type="button" aria-label={`Trigger chikari drone ${index + 1}`} data-control-target={index === 0 ? "sitar-chikari" : undefined} onClick={() => props.onControl("sitar_chikari")}>
            Chikari {index + 1}
          </button>
        ))}
        <button type="button" aria-label="Trigger sitar meend drag" data-control-target="sitar-meend" onClick={() => triggerMomentary(props, "D4", "meend", 0.78, 760)}>
          Meend drag
        </button>
        <select aria-label="Sitar meend limit mode" defaultValue="standard" onChange={(event) => props.onControl("sitar_meend_mode", event.currentTarget.value)}>
          <option value="beginner">Beginner 300c</option>
          <option value="standard">Standard 500c</option>
          <option value="expert">Expert 700c</option>
        </select>
      </div>
    </div>
  );
}
